"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const prop_types_1 = __importDefault(require("prop-types"));
const classnames_1 = __importDefault(require("classnames"));
const BannerBase_1 = __importDefault(require("../BannerBase/BannerBase"));
const utils_1 = require("./utils");
const promotion_banner_module_scss_1 = __importDefault(require("./promotion-banner.module.scss"));
const PromotionBanner = ({ className, promotionData = {}, vanityURLs = {}, dataSelector = 'promo-sales-banner', isBannerHidden, csrPersonalization = {}, ...others }) => {
    if (csrPersonalization.enabled) {
        (0, utils_1.applyPersonalizationCopy)(promotionData, csrPersonalization.marketChannel);
    }
    const bannerData = (0, utils_1.getSitewideBannerData)(promotionData, vanityURLs);
    const { messageDesktop, messagePrefixConfig, theme, action, actionText, sitewidePromo } = bannerData;
    const classes = (0, classnames_1.default)(promotion_banner_module_scss_1.default.sitewideContainer, {
        'u-hidden': isBannerHidden
    }, className);
    return ((0, jsx_runtime_1.jsx)(BannerBase_1.default, { messageDesktop: messageDesktop, messagePrefixConfig: messagePrefixConfig, theme: theme, action: action, actionText: actionText, className: classes, contentClassName: promotion_banner_module_scss_1.default.sitewideContent, dataSelector: dataSelector, mobileMessageDataSelector: 'promoBannerMsg', desktopMessageDataSelector: 'promoBannerMsgMobile', sitewidePromo: sitewidePromo, ...others }));
};
PromotionBanner.propTypes = {
    /** Applies a custom class to the CoreNavigation component's wrapping header element. */
    className: prop_types_1.default.string,
    /** Object with promotion data such as sitewidePromo and pageMessaging  */
    promotionData: prop_types_1.default.object.isRequired,
    /** Object to add message prefixes to the banner according to vanity URLs  */
    vanityURLs: prop_types_1.default.object,
    /** Option to hide/display the banner  */
    isBannerHidden: prop_types_1.default.bool,
    /** Data selector for testing and analitics purposes */
    dataSelector: prop_types_1.default.string,
    /** Obj that holds the necessary info for handling the csr personalization overrides */
    csrPersonalization: prop_types_1.default.shape({
        enabled: prop_types_1.default.bool,
        marketChannel: prop_types_1.default.string,
    })
};
exports.default = PromotionBanner;
//# sourceMappingURL=promotion-banner.js.map